export default "__VITE_ASSET__Bbvm4Tgj__"